import React from "react";
import "./work-card.css";
function WorkCard ({ item }) {
  return (
    <div className="work-card">
      <div className="work-info">
        <div className="work-header">
          <div className="work-title-section">
            <label className="certificate-name">{item.company}</label>
            <div className="certificate-provider">
              <label>{item.designation}</label>
            </div>
          </div>
          <div className="work-meta">
            <span className="certificate-duration">{item.dateJoining} - {item.dateEnd}</span>
          </div>
        </div>
        <div className="work-description">
          <p>{item.work}</p>
        </div>
      </div>
    </div>
  );
}

export default WorkCard;